<template>
	<form action="" class="scan-box">
		<label for="" class="scan-box__label">Scan Barcode</label>
		<textarea
			class="scan-box__input"
			placeholder="Click here and scan barcode, one item barcode each line"
			v-model="item_serials"
			name="item_serials"
			type="text"
		></textarea>
		<input type="button" value="Create Label" v-on:click="scan" />
	</form>
</template>

<script>
import Vue from "vue";
import axios from "axios";
export default Vue.extend({
	name: "",
	components: {},
	props: ['type'],
	data() {
		return {
			item_serials: "",
			//deliveryResp: {}
		};
	},
	methods: {
		async loadZones(){
			let data = {
				item_serial: this.item_serials.replaceAll("\n", ","),
				handler: "test",
				process: this.type,
				sessionid: this.$store.getters.sessionid
				
			};
			await this.$store.dispatch('scanRequest', data);
		},
		scan: function() {
		
		console.log(this.type);
		
		//alert('Enter was pressed');
		
			
			this.loadZones();
			
			//alert('Done');
			
			this.item_serials = "";
			this.item_serials.$el.focus();
		
		}
	},
	
  
});
</script>

<style lang="scss" scoped>
.scan-box {
	padding: 20px 0 30px;

	&__label {
		// text-transform: uppercase;
		text-align: center;
		display: block;
		margin-bottom: 10px;
		font-weight: 600;
		font-size: 16px;
	}

	&__input {
		border: 1px solid $border-color;
		border-radius: 5px;
		font-size: 14px;
		display: block;
		margin: 0 auto;
		text-align: center;
		padding: 7px 0;
		width: 300px;
	}
}
</style>